import {
  SET_MEDIAVIEWIER,
  SET_SHOW_SMALL_VIEW_PORT,
  SET_SELECTED_MEDIA,
  SET_SELECTED_INDEX,
  SET_DISPLAY,
  SET_PANO_FULL_SCREEN,
  SET_SHOW_MEDIA_OBJ,
  SET_ERROR_IDX,
  SET_MEDIA_PARAM,
  MediaViewerActionTypes,
} from "./actions";

const initialState = {
  showMediaViewer: null,
  showSmallViewPort: false,
  selectedMedia: null,
  selectedIndex: 0,
  display: false,
  panoFullScreen: false,
  showMediaObj: false,
  errorIdx: [],
  mediaParam: null,
};

const MediaViewerReducer = (
  state = initialState,
  action: MediaViewerActionTypes
) => {
  switch (action.type) {
    case SET_MEDIAVIEWIER:
      return { ...state, showMediaViewer: action.payload };
    case SET_SHOW_SMALL_VIEW_PORT:
      return { ...state, showSmallViewPort: action.payload };
    case SET_SELECTED_MEDIA:
      return { ...state, selectedMedia: action.payload };
    case SET_SELECTED_INDEX:
      return { ...state, selectedIndex: action.payload };
    case SET_DISPLAY:
      return { ...state, display: action.payload };
    case SET_PANO_FULL_SCREEN:
      return { ...state, panoFullScreen: action.payload };
    case SET_SHOW_MEDIA_OBJ:
      return { ...state, showMediaObj: action.payload };
    case SET_ERROR_IDX:
      return { ...state, errorIdx: action.payload };
    case SET_MEDIA_PARAM:
      return { ...state, mediaParam: action.payload };
    default:
      return state;
  }
};

export default MediaViewerReducer;
